export const getAvailableMenuItems = (items = []) =>
    items.reduce((result, { isHidden, children, ...item }) => {
        if (isHidden) return result;
        return [...result, { ...item, ...(children ? { children: getAvailableMenuItems(children) } : {}) }];
    }, []);
